import styles from './styles.module.scss';

export const Break = () => (
  <div className={styles.breakContainer}>
    <div className={styles.break} />
  </div>
);
